export const locale = {
  ivxHint: (ivxLabel: string): string => {
    return `IVX is the composite measure of the stock\'s implied volatility calculated from an option\'s price using proprietary methodology. See IVolatility knowledge base for more details. IVX ${ivxLabel} is calculated for the forward ${ivxLabel} calendar days`;
  },
  hvHint: (hvLabel: string): string => {
    return `Historical Volatility ${hvLabel} Days. Actual volatility that occurred to the underlying stock during the prior ${hvLabel} trading days`;
  },
  disabledHvHint: 'Historical Volatility is calculated at close. Data is only available in 1Mo, 3Mo, 6Mo, 1Y, and 5Y resolutions. To enable HV, please select a supported resolution'
};
